export class RouteWithIndex {
  public route: string;
  public index: number;

  constructor(route: string, index: number) {
    this.route = route;
    this.index = index;
  }
}


export const SELF_ACTUAL_ROUTE = new RouteWithIndex('/', 0);
export const SELF_HISTORY_LIST_ROUTE = new RouteWithIndex('/self/history', 1);
export const SELF_HISTORY_ROUTE = {
  selfHistory: (questionnaireId: number) => new RouteWithIndex(`${SELF_HISTORY_LIST_ROUTE.route}/${questionnaireId}`, SELF_HISTORY_LIST_ROUTE.index)
};
export const EXTERNAL_ACTUAL_LIST_ROUTE = new RouteWithIndex('/external/actual', 2);
export const EXTERNAL_ACTUAL_ROUTE = {
  externalActual: (questionnaireId: number) => new RouteWithIndex(`${EXTERNAL_ACTUAL_LIST_ROUTE.route}/${questionnaireId}`, EXTERNAL_ACTUAL_LIST_ROUTE.index)
};
export const EXTERNAL_HISTORY_LIST_ROUTE = new RouteWithIndex('/external/history', 3);
export const EXTERNAL_HISTORY_ROUTE = {
  externalHistory: (questionnaireId: number) => new RouteWithIndex(`${EXTERNAL_HISTORY_LIST_ROUTE.route}/${questionnaireId}`, EXTERNAL_HISTORY_LIST_ROUTE.index)
};
export const EMPLOYEES_ROUTE = new RouteWithIndex('/employee', 4);
export const QUESTIONNAIRE_ROUTE = new RouteWithIndex('/questionnaire', 5);
export const CATALOGUE_ROUTE = new RouteWithIndex('/questioncatalogue', 6);
export const CREATE_CATALOGUE_ROUTE = new RouteWithIndex(CATALOGUE_ROUTE.route +'/create', CATALOGUE_ROUTE.index);
export const EVALUATION_LIST_ROUTE = new RouteWithIndex('/evaluation', 7);
export const EVALUATION_ROUTE = {
  evaluation: (questionnaireId: number) => new RouteWithIndex(`${EVALUATION_LIST_ROUTE.route}/${questionnaireId}`, EVALUATION_LIST_ROUTE.index)
};
